import clsx from 'clsx'
import Image from 'next/image'
import { useRouter } from 'next/router'
import type { FunctionComponent, ReactNode } from 'react'
import React from 'react'
import { DropzoneProps, DropzoneRef, useDropzone } from 'react-dropzone'
import { useThumbnail } from '../utils/ThumbnailContext'
import { Button } from './Buttons'
import styles from './CustomUpload.module.sass'
import { Icon, IconName } from './Icon'

export type CustomUploadProps = DropzoneProps &
	React.RefAttributes<DropzoneRef> & {
		iconDecoration?: IconName
		areaDescription?: ReactNode
		footerDescription?: ReactNode
		small?: boolean
	}

export const CustomUpload: FunctionComponent<CustomUploadProps> = ({
	maxFiles = 5,
	iconDecoration,
	areaDescription,
	footerDescription,
	...props
}) => {
	const {
		getRootProps,
		getInputProps,
		isDragAccept,
		isDragReject,
		isFocused,
		acceptedFiles,
		open,
		fileRejections,
	} = useDropzone({
		maxFiles,
		...props,
	})

	// const fileTypeIcon = (type: string) => {
	// 	if (type.includes('image')) {
	// 		return <Icon name="imageIllustration" />
	// 	} else if (type.includes('video')) {
	// 		return <Icon name="videoIllustration" />
	// 	} else if (type.includes('pdf')) {
	// 		return <Icon name="pdfIllustration" />
	// 	}
	// 	return null
	// }

	const locale = useRouter().locale

	//const [thumbnail, setThumbnail] = React.useState<string>()
	const thumbnail = useThumbnail()

	return (
		<div className={styles.wrapper}>
			<div
				className={clsx(
					styles.dropzone,
					isFocused && styles.is_focused,
					isDragAccept && styles.is_dragAccept,
					isDragReject && styles.is_dragReject
				)}>
				{!props.small && (
					<div {...getRootProps()} className={styles.area}>
						<input {...getInputProps()} />
						<div className={styles.areaContent}>
							{iconDecoration && (
								<div className={styles.areaIcon}>
									<Icon name={iconDecoration} />
								</div>
							)}
							{areaDescription}
						</div>
					</div>
				)}
				{acceptedFiles.length > 0 && (
					<div className={styles.acceptedFiles}>
						{acceptedFiles.map((item, index) => (
							<div key={`${item.name + index}`} className={styles.acceptedFile}>
								<div className={styles.acceptedFilePreview}>
									<Image
										src={URL.createObjectURL(item)}
										alt="uploaded image"
										width={40}
										height={40}
										style={{ objectFit: 'cover', borderRadius: '5px' }}
									/>
								</div>
								{/* <div className={styles.acceptedFileName}>{item.name}</div> */}
								{thumbnail.thumbnail !== item.name && (
									<Button
										type="button"
										size={3}
										fontSize="small"
										fill="grey100"
										onClick={() => {
											thumbnail.setThumbnail(item.name)
										}}>
										Set as a thumbnail
									</Button>
								)}
								{thumbnail.thumbnail == item.name && (
									<span style={{ fontSize: '14px' }}>Thumbnail</span>
								)}
							</div>
						))}
					</div>
				)}
				{fileRejections.length > 0 && (
					<div className={styles.error}>
						<h4 className={styles.errorTitle}>Errors</h4>
						<ul className={styles.errorList}>
							{fileRejections.map(({ file, errors }) => (
								<li key={file.type}>
									File name: {file.name}
									<ul className={styles.errorListItems}>
										{errors &&
											errors.map((error) => (
												<li key={error.code} className={styles.errorListItem}>
													{error.message}
												</li>
											))}
									</ul>
								</li>
							))}
						</ul>
					</div>
				)}
				<div className={clsx(styles.footer, props.small && styles.footerSmall)}>
					<Button type="button" fill="grey100" onClick={open}>
						{/* @translation */}
						{locale === 'cs' ? 'Nahrát fotku' : 'Upload photo'}
					</Button>
					{footerDescription && <div className={styles.footerDescription}>{footerDescription}</div>}
				</div>
			</div>
		</div>
	)
}
